import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const logar = async (cpf: string, password: string) => {
  const response = await axios.post(`${API_URL}/login`, { cpf, password });
  return response.data;
};
export default logar;
